var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65903 9.49609L6.64058 9.01529L6.40207 10.0984L10.1876 11L11 6.8587L9.9534 6.63645L9.52194 8.83675L7.07845 4.79694H2.46913L1.01812 0L0 0.333379L1.68595 5.9082H6.48893L8.65903 9.49609Z",
    fill: "#C13C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossIcon);
export default __webpack_public_path__ + "static/media/lossIcon.7939f874e58c5fb9eddde1d82c5714eb.svg";
export { ForwardRef as ReactComponent };